<template>
  <main id="register-wrapper">


    <div id="registerpage">
      <breadcrumb
        :breadcrumb="[
          { title: 'Community', url: app_url, status: false },
          { title: 'HCID', url: app_url+'/hcid', status: false },
          { title: 'Edit Phone Number', url: app_url+'/phone-number', status: false },
        ]"
      ></breadcrumb>
      <div
        class="modal fade"
        id="modalNext"
        tabindex="-1"
        role="dialog"
        aria-labelledby="modalNextLabel"
        aria-hidden="true"
      >
        <div class="modal-dialog" role="document" ref="modal">
          <div class="modal-content">
            <div class="modal-header">
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body text-center px-5 mb-5">
              <h3 class="modal-title">Konfirmasi</h3>
              <div class="row py-2">
                <div class="col">
                  <p>Apakah Anda sudah yakin data No Telepon yang Anda masukkan sudah benar ?</p>
                </div>
              </div>
              <div class="row py-2">
                <div class="col">
                  <button type="button" class="btn btn-white mx-1" data-dismiss="modal" @click="stopAction()">
                    Tidak
                  </button>
                  <button type="button" class="btn btn-red mx-1" @click="nextAction()">
                    Iya, Lanjutkan
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="container py-5" v-if="!showOtp">
        <div class="row justify-content-center">
         <div v-if="submitLoader" class="loading loading-double"></div>
          <div v-else class="col-md-6">
             <form
                method="POST"
                @submit.prevent="onSubmit"
                @keydown="form.errors.clear($event.target.name)"
                enctype="multipart/form-data"
            >
            <div id="card-register" class="card">
              <div class="card-body">
                <h3 class="title">Verifikasi No. Handphone</h3>


                  <div class="form-group row">
                      <div class="col">
                          <label class="label-form" for="email">Email Anda</label>
                          <input
                              type="text"
                              class="form-control form-register"
                              id="email"
                              aria-describedby="email"
                              placeholder="mail@astra-honda.com"
                              v-model="form.email"
                              :disabled="user.email ? true : false"
                          />
                          <span
                          class="help-block"
                          v-if="form.errors.has('email')"
                          v-text="form.errors.get('email')"
                          >
                          </span>
                      </div>
                  </div>
                  <div class="form-group row">
                    <div class="col">
                      <label class="label-form" for="hp">Masukkan No Telepon</label>
                        <div class="phonebox">
                            <span class="input62">+62</span>
                            <input
                                type="number"
                                class="form-control form-register"
                                id="hp"
                                aria-describedby="hp"
                                placeholder="8XXXXXXXX"
                                 v-model="form.phone"
                            />
                        </div>
                        <span v-if="showWarning">Pastikan nomor Handphone yang digunakan sudah benar, jika sudah silahkan klik Selanjutnya</span>
                        <span
                        class="help-block"
                        v-if="form.errors.has('phone')"
                        v-text="form.errors.get('phone')"
                        >
                        </span>
                    </div>
                  </div>
                  <br />
                  <div class="row justify-content-center">
                    <button
                      @click="pushVerifikasi()"
                      type="button"
                      class="btn mx-2 btn-red"
                      data-toggle="modal"
                      data-target="#modalNext"
                    >
                      Selanjutnya
                    </button>
                  </div>
              </div>
            </div>
            </form>
          </div>
        </div>
      </div>


      <div class="container py-5"  v-if="showOtp">
        <div class="row justify-content-center">
         <div v-if="submitLoader" class="loading loading-double"></div>
          <div v-else class="col-md-6">
             <form
                v-if="!showPin"
                method="POST"
                @submit.prevent="onSubmitWithOtp"
                @keydown="otpForm.errors.clear($event.target.name)"
                enctype="multipart/form-data"
            >
            <div id="card-register" class="card">
              <div class="card-body">
                <div class="message-box" v-if="showMessageOtp">
                    <div class="message-content">
                          <div v-html="member.message"></div>
                        <button class="btn btn-red" @click="showMessageOtp = !showMessageOtp"> Selanjutnya </button>
                    </div>
                </div>
                <h3 class="title">Verifikasi No. Handphone</h3>
                  <div class="form-group row">
                      <div class="col">
                          <label class="label-form" for="email">Email Anda</label>
                          <input
                              type="text"
                              class="form-control form-register"
                              id="email"
                              aria-describedby="email"
                              placeholder="mail@astra-honda.com"
                              v-model="otpForm.email"
                          />
                          <span
                          class="help-block"
                          v-if="otpForm.errors.has('email')"
                          v-text="otpForm.errors.get('email')"
                          >
                          </span>
                      </div>
                  </div>
                  <div class="form-group row">
                    <div class="col">
                      <label class="label-form" for="hp">Masukkan No Telepon</label>
                        <div class="phonebox">
                            <span class="input62">+62</span>
                            <input
                                type="number"
                                class="form-control form-register"
                                id="hp"
                                aria-describedby="hp"
                                placeholder="8XXXXXXXX"
                                    v-model="otpForm.phone"
                                disabled
                            />
                        </div>
                        <span
                        class="help-block"
                        v-if="otpForm.errors.has('phone')"
                        v-text="otpForm.errors.get('phone')"
                        >
                        </span>
                    </div>
                  </div>
                  <div class="form-group row">
                    <div class="col">
                      <label class="label-form" for="hp">Kode OTP</label>
                      <input
                        type="number"
                        class="form-control form-register"
                        id="otp"
                        aria-describedby="otp"
                        placeholder="Masukkan No OTP"
                        v-model="otpForm.otp"
                        v-mask="'######'"
                      />
                        <span
                        class="help-block"
                        v-if="otpForm.errors.has('otp')"
                        v-text="otpForm.errors.get('otp')"
                        >
                        </span>
                    </div>
                  </div>
                <div class="form-group row">
                    <div class="col">
                    <label class="label-form" for="pin">Masukkan PIN Baru</label>
                    <input
                        type="number"
                        class="form-control form-register"
                        id="pin"
                        aria-describedby="pin"
                        placeholder="PIN Harus berupa 6 Angka"
                        v-model="otpForm.pin"
                        v-mask="'######'"

                    />
                        <span
                        class="help-block"
                        v-if="otpForm.errors.has('pin')"
                        v-text="otpForm.errors.get('pin')"
                        >
                        </span>
                    </div>
                </div>
                <div class="form-group row">
                    <div class="col">
                    <label class="label-form" for="hp">Konfirmasi Pin</label>
                    <input
                        type="number"
                        class="form-control form-register"
                        id="pin_confirmation"
                        aria-describedby="pin_confirmation"
                        placeholder="Konfirmasi Pin"
                        v-model="otpForm.pin_confirmation"
                        v-mask="'######'"
                    />
                        <span
                        class="help-block"
                        v-if="otpForm.errors.has('pin_confirmation')"
                        v-text="otpForm.errors.get('pin_confirmation')"
                        >
                        </span>
                    </div>
                </div>
                  <div class="row justify-content-center">
                      <div style="text-align:center;">
                            <button
                            type="submit"
                            class="btn mx-2 btn-red"
                            :disabled="countDown != 0"
                            @click="backOTp"
                            >
                            Kirim Ulang OTP
                            </button><br>
                           <small v-if="countDown > 0"> Kirim Ulang OTP Dalam {{countDown}} Detik</small>
                      </div>
                    <button
                      type="submit"
                      class="btn mx-2 btn-red"
                    >
                      Verifikasi
                    </button>
                  </div>
              </div>
            </div>
            </form>
            <form
                v-if="showPin"
                method="POST"
                @submit.prevent="onSubmitPin"
                @keydown="otpFormPin.errors.clear($event.target.name)"
                enctype="multipart/form-data"
            >
            <div id="card-register" class="card">
            <div class="card-body">
                <h3 class="title">Atur Pin</h3>
                <div class="form-group row">
                    <div class="col">
                    <label class="label-form" for="pin">Masukkan PIN Baru</label>
                    <input
                        type="number"
                        class="form-control form-register"
                        id="pin"
                        aria-describedby="pin"
                        placeholder="PIN Harus berupa 6 Angka"
                        v-model="otpFormPin.pin"
                        v-mask="'######'"

                    />
                        <span
                        class="help-block"
                        v-if="otpFormPin.errors.has('pin')"
                        v-text="otpFormPin.errors.get('pin')"
                        >
                        </span>
                    </div>
                </div>
                <div class="form-group row">
                    <div class="col">
                    <label class="label-form" for="hp">Konfirmasi Pin</label>
                    <input
                        type="number"
                        class="form-control form-register"
                        id="pin_confirmation"
                        aria-describedby="pin_confirmation"
                        placeholder="Konfirmasi Pin"
                        v-model="otpFormPin.pin_confirmation"
                        v-mask="'######'"
                    />
                        <span
                        class="help-block"
                        v-if="otpFormPin.errors.has('pin_confirmation')"
                        v-text="otpFormPin.errors.get('pin_confirmation')"
                        >
                        </span>
                    </div>
                </div>
                <br />
                <div class="row justify-content-center">
                    <button
                    type="submit"
                    class="btn mx-2 btn-red"
                    >
                    Daftar
                    </button>
                </div>
            </div>
            </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </main>
</template>
<script>
import { isMobile } from "mobile-device-detect";
import BreadCrumb from "../../widget/BreadCrumb";
import 'vue-select/dist/vue-select.css';
import vSelect from "vue-select";
import { sha256 } from 'js-sha256';

export default {
  components: {
    breadcrumb: BreadCrumb,
    "v-select": vSelect,
  },
  data() {
    return {
        base_url:'',
        app_url:'',
        api_url:'',
        main_site_url:main_site_url,
        mobile: false,
        page: 1,
        token:'',
        showOtp:false,
        showPin:false,
        showWarning:false,
        loadderforms:false,
        submitLoader:false,
        countDown:60,
        showMessageOtp:false,
        member:null,
        tokenForm: new Form({
            token:'',
        }),
        user:null,
        otpForm: new Form({
                _token:token,
               email:'',
               phone:'',
               pin:'',
               pin_confirmation:'',
               otp:'',
        }),
        otpFormPin: new Form({
            _token:token,
            email:'',
            phone:'',
            pin:'',
            pin_confirmation:'',
        }),
        form: new Form({
                _token:token,
               email:'',
               phone:'',
            }),
        };
  },
  watch: {
      otpForm: {
          handler: function(val, oldVal) {
                this.otpForm.email = val.email.toLowerCase();
          },
          deep: true
      },
      otpFormPin: {
          handler: function(val, oldVal) {
                this.otpFormPin.email = val.email.toLowerCase();
          },
          deep: true
      },
      form: {
          handler: function(val, oldVal) {
                this.form.email = val.email.toLowerCase();
          },
          deep: true
      }
  },
  created() {
    this.base_url = base_url;
    this.app_url = app_url;
    this.api_url = api_url;
    this.mobile = isMobile;
    if (localStorage.getItem('socmed') != null) {
      var socmed = localStorage.getItem('socmed');
      var data = {
          'event': 'Register Step 1',
          'eventCategory': 'Registration',
          'eventAction': 'Select register method',
          'eventLabel': socmed,
      };
      console.log(data);
      dataLayer.push(data);
    }
    if(localStorage.getItem('user') != null){
        this.user = JSON.parse(localStorage.getItem('user'));
        this.form.email = this.user.email;
        this.defaulUser();
    }
  },
  methods: {
    defaulUser(){
       this.form.phone = this.user.phone;
    },
    onSubmit() {
      this.submitLoader = true;
      this.form.post(api_url+"/member/otp")
        .then((response) => {
            // let nomer_encrypt = sha256(response.phoneEncrypt);
            // this.gtmTrackerStep2(nomer_encrypt);
            // localStorage.setItem('nmr', nomer_encrypt);
            this.submitLoader = false;
            this.showMessageOtp = true;
            this.form.phone = response.phone;
            this.form.email = response.email;
            this.otpForm.phone = response.phone;
            this.otpForm.email = response.email;
            this.member = response.member;
            this.showOtp = true;
            this.countDown = 60;
            this.countDownTimer();
            // if(response.old){
            //   this.tokenForm.token = response.token;
            //   this.getUser()
            // }else{
            //     this.showMessageOtp = true;
            //     this.otpForm.phone = response.phone;
            //     this.otpForm.email = response.email;
            //     this.member = response.member;
            //     this.showOtp = true;
            //     this.countDown = 60;
            //     this.countDownTimer();
            // }
        })
        .catch((response) => {
            console.log(response);
            if(response.expired){
              window.location.href = this.app_url + '/register/independent'
              localStorage.clear();
            }
            this.submitLoader = false;
        });
    },
    onSubmitWithOtp() {
      this.submitLoader = true;
      this.otpForm.post(api_url+"/member/update_phone")
        .then((response) => {
            this.submitLoader = false;
            if(response.status){
                this.gtmTrackerStep4(localStorage.getItem('nmrphone'));
                localStorage.setItem('user',JSON.stringify(response.data))
                if(response.data.completed==true || response.data.completed=='true'){
                        window.location.href = this.app_url + '/hcid'
                }else{
                    window.location.href = this.app_url + '/register-user'
                }
            }
        })
        .catch((response) => {
          this.submitLoader = false;
          this.defaulUser();
          console.log("ERROR");
        });
    },
    backOTp(){
      this.showOtp = false;
      this.showWarning = true;
      var phoneEncrypt = localStorage.getItem('nmrphone');
      var data = {
        'event': 'Register Step 4',
        'eventCategory': 'Registration',
        'eventAction': 'OTP verification',
        'eventLabel': 'Resend OTP', // or Resend OTP
        'user_id': phoneEncrypt
      };
      console.log('step 4');
      console.log(data);
      dataLayer.push(data);
    },
    onSubmitPin() {
        this.otpFormPin.post(api_url+"/member/register-pin")
        .then((response) => {
            if(response.status){
                localStorage.setItem('user',JSON.stringify(response.data))
                if(response.data.completed==true || response.data.completed=='true'){
                        window.location.href = this.app_url + '/hcid'
                }else{
                    window.location.href = this.app_url + '/register-user'
                }
            }
        })
        .catch((response) => {
                console.log("ERROR");
        });
    },
    countDownTimer() {
        if(this.countDown > 0) {
            setTimeout(() => {
                this.countDown -= 1
                this.countDownTimer()
            }, 1000)
        }
    },
    nextAction() {
      this.onSubmit();
      this.toggleModal();
      var phone = sha256(this.form.phone);
      var encrypt = sha256(phone);
      console.log(encrypt);
      var data = {
          'event': 'Register Step 3',
          'eventCategory': 'Registration',
          'eventAction': 'Confirm phone number',
          'eventLabel': 'Yes', // or No
          'user_id': encrypt
      }
      console.log('Step 3');
      console.log(data);
      dataLayer.push(data);
    },
    stopAction() {
      var data = localStorage.getItem('nmrphone');
      console.log(data);
      var data = {
        'event': 'Register Step 3',
        'eventCategory': 'Registration',
        'eventAction': 'Confirm phone number',
        'eventLabel': 'No', // or No
        'user_id': data
      }
      console.log('Step 3');
      console.log(data);
      dataLayer.push(data);
    },
    toggleModal() {
      $("#modalNext").modal("toggle");
      $(".modal-backdrop").remove();
    },
    pushVerifikasi() {
      let phone = this.form.phone;
      let phoneEncrypt = sha256(phone);
      let getEncrypt = sha256(phoneEncrypt);
      localStorage.setItem('nmrphone', getEncrypt);

      var data = {
            'event': 'Register Step 2',
            'eventCategory': 'Registration',
            'eventAction': 'Submit phone number',
            'eventLabel': getEncrypt,
        };
        console.log('step 2');
        console.log(data);
        dataLayer.push(data);

    },
    // gtmTrackerStep2(getdata) {
    //     // let phoneEncrypt = sha
    //     var data = {
    //         'event': 'Register Step 2',
    //         'eventCategory': 'Registration',
    //         'eventAction': 'Submit phone number',
    //         'eventLabel': getdata,
    //     };
    //     console.log('step 2');
    //     console.log(data);
    //     dataLayer.push(data);
    // },
    gtmTrackerStep4(getdata) {
      var data = {
        'event': 'Register Step 4',
        'eventCategory': 'Registration',
        'eventAction': 'OTP verification',
        'eventLabel': 'Verify', // or Resend OTP
        'user_id': getdata
      };
      console.log('step 4');
      console.log(data);
      dataLayer.push(data);
    },
  },
};
</script>
<style lang="scss">
  #registerpage{
    .vue-input-tag-wrapper .input-tag {
      background: #282828;
      border-radius: 10px;
      color: #FFFFFF;
      align-self: center;
      font-style: normal;
      font-weight: 300;
      font-size: 14px;
      line-height: 24px;
      padding: 5px 1rem 5px 1rem !important;
      margin-bottom: 0px;
    }
    @media (max-width: 768px) {
      .vue-input-tag-wrapper .input-tag {
        background: #E61B33;
        line-height: 22px;
        height: 25px;
        padding: 0px 1rem 0px 1rem !important;
      }
    }
  }
</style>
<style scoped lang="scss">
.colpage{
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    .pageform{
        display: flex;
        justify-content: center;
        align-items: center;
        margin:0 20px;
        .numberpage{
            display: block;
            width: 35px; height: 35px;
            display: flex;
            justify-content: center;
            align-items: center;
            background-color:#4F4F4F;
            border-radius:100px;
            font-weight: bold;
        }
        .infopage{
            font-weight: bold;
            color:#4F4F4F;
            margin-left: 15px;
        }
    }
    .pageform.active{
        .numberpage{
            background-color:#7AE798;
        }
        .infopage{
            color:#7AE798;
        }
    }
}
#registerpage {
  background: #000000;
  font-family: Manrope;
  .card {
    background: #ffffff;
    border-radius: 10px;
    /* font-family: Inter; */
  }
  .title {
    color: #000000;
    font-style: normal;
    font-weight: 600;
    font-size: 20px;
    line-height: 30px;
    margin-bottom: 1rem;
  }
  .label-form {
    font-style: normal;
    font-weight: 600;
    font-size: 12px;
    line-height: 24px;
    color: #3f3f3f;
  }
  .form-register {
    border-radius: 10px;
    border: 1px solid #dbdbdb;
    box-sizing: border-box;
    padding:11px;
    height: auto;
  }
  ::placeholder {
    color: #727272;
    font-style: normal;
    font-weight: 300;
    font-size: 14px;
    line-height: 24px;
  }
  select {
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    background: url(/images/arrow-select.png) no-repeat right white;
    background-position-x: 98.5%;
  }
  .form-check {
    font-style: normal;
    font-weight: 300;
    font-size: 14px;
    line-height: 22px;
    color: #000000;
  }

  .btn {
    width: 161px;
    height: 50px;
  }
  .btn-white {
    border: 1px solid #dbdbdb;
    box-sizing: border-box;
    border-radius: 10px;
    font-style: normal;
    font-weight: 600;
    font-size: 14px;
    line-height: 24px;
    text-align: center;
    color: #e61b33;
  }
  .btn-red {
    background: #e61b33;
    border-radius: 10px;
    font-style: normal;
    font-weight: 600;
    font-size: 14px;
    line-height: 24px;
    text-align: center;
    color: #ffffff;
  }
  .title-row {
    background: #191919;
    opacity: 0.95;
    font-style: normal;
    font-weight: 600;
    font-size: 32px;
    line-height: 42px;
    color: #ffffff;
  }
  .title-row-info {
    background: #1e1e1e;
  }
  .modal-content {
    background: #ffffff;
    border-radius: 10px;
  }
  .modal-header {
    border-bottom: unset;
  }
  .modal-title {
    font-style: normal;
    font-weight: 600;
    font-size: 20px;
    line-height: 30px;
    color: #e61b33;
  }
  .breadcrumb-image {
    max-height: 25px;
    display: inline-flex;
  }
  .breadcrumb-image-mobile {
    max-height: 25px;
    display: none;
  }
  .fa {
    cursor: pointer;
  }
  .fa-active {
    color: #4f4f4f;
  }
  .fa-not-active {
    color: #b4b4b4;
  }
  .row-eye {
    right: 35px;
    bottom: 155px;
    position: absolute;
    z-index: 1;
  }
  .row-password-eye {
    right: 35px;
    bottom: 265px;
    position: absolute;
    z-index: 1;
  }
  @media (max-width: 768px) {
    select {
      background-position-x: 95.5%;
    }
    .title {
      font-size: 18px;
    }
    .label-form {
      font-weight: 300;
    }
    .form-register {
      height: 40px;
    }
    .row-password-eye {
      bottom: 240px;
    }
    .row-eye {
      bottom: 145px;
    }
    .btn {
      width: 120px;
    }
    .modal-body {
      padding-left: 1.5rem !important;
      padding-right: 1.5rem !important;
    }
    .breadcrumb-image {
      display: none;
    }
    .breadcrumb-image-mobile {
      display: inline-flex;
    }
  }
}
.card-body{
    position: relative;
    color:#333;
}
.message-box{
    position: absolute;
    background: #fff;
    width: 100%;
    height: 100%;
    left: 0;
    top: 0;
    border-radius: 20px;
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 10;
    .message-content{
        max-width: 80%;
        margin:auto;
        .btn{
            text-align: center;
        }
    }
}
</style>
